import React from 'react';

import TaskFormModal from '../../task_modal';
import { useTasks } from '../context/tasks_context';

import type { TaskAttributes } from 'bundles/apex/tasks/types';

export function TasksModal() {
  const {
    addTaskAttachment,
    allowParentSelection,
    createTask,
    deleteTask,
    disableAssignee,
    forUser,
    loading,
    options,
    pagination,
    paths,
    reloadTasks,
    removeTaskAttachment,
    selectedTask,
    setPage,
    setShowModal,
    showModal,
    showTaskModal,
    tasks,
    updateTask,
  } = useTasks();

  // The modal uses the current task state for some things (e.g. attachments), so storing the task
  // in state is no good - always pass the current value in. However, doing only that is problematic
  // during pagination when the task lookup is temporarily null, so store and use both.
  // TODO: Obviously, this is very messy - clean up how the modal works
  const currentModalTask = tasks.find(task => task.id === selectedTask?.id);
  const modalTaskIndex = currentModalTask ? tasks.indexOf(currentModalTask) : -1;
  let hasPrevious = false, hasNext = false;
  if (currentModalTask) {
    hasPrevious = modalTaskIndex > 0 || (!!pagination && pagination.currentPage > 1);
    hasNext = modalTaskIndex < tasks.length - 1 || (!!pagination && pagination.currentPage < pagination.totalPages);
  }

  async function selectPreviousTask() {
    if (modalTaskIndex > 0) {
      showTaskModal(tasks[modalTaskIndex - 1]);
    } else if (pagination) {
      const newTasks = await setPage(pagination.currentPage - 1);
      showTaskModal(newTasks[newTasks.length - 1]);
    }
  }

  async function selectNextTask() {
    if (modalTaskIndex < tasks.length - 1) {
      showTaskModal(tasks[modalTaskIndex + 1]);
    } else if (pagination) {
      const newTasks = await setPage(pagination.currentPage + 1);
      showTaskModal(newTasks[0]);
    }
  }

  return <>
    <TaskFormModal
      allowParentSelection={allowParentSelection}
      attachmentsPath={selectedTask ? paths.attachments : undefined}
      canDeleteAttachments
      checkImmediateRemindersPath={paths.checkForImmediateReminders}
      createTask={(task: Partial<TaskAttributes>) => createTask({ assigneeId: forUser.id, ...task } as TaskAttributes)}
      currentTask={currentModalTask}
      disableAssignee={disableAssignee || !!selectedTask?.parent?.private}
      formDependenciesPath={(selectedTask || paths).formDependenciesPath}
      forUser={forUser}
      hasNext={hasNext}
      hasPrevious={hasPrevious}
      options={options}
      reloadTasks={reloadTasks}
      reminders={selectedTask?.reminders?.filter(reminder => reminder.userId === forUser.id)}
      show={showModal}
      showAdditionalOptions
      task={selectedTask}
      updateTask={updateTask}
      onAddAttachment={addTaskAttachment}
      onDelete={deleteTask}
      onDeleteAttachment={removeTaskAttachment}
      onHide={() => setShowModal(false)}
      onNext={selectNextTask}
      onPrevious={selectPreviousTask}
    />
  </>;
}
